
import { Avatar, Button, Image, Input } from 'antd';
import IsLoading from '../../common/isLoading';
import { CameraOutlined, CheckOutlined, CloseOutlined, CloudUploadOutlined, LoadingOutlined, SaveOutlined } from '@ant-design/icons';
import { useEffect, useImperativeHandle, useRef, useState } from 'react';
import FetchData from '../../hook/fetchData';
import useAlert from '../../common/alert';
import { TextboxFlex } from '../../common/textbox.js';
import { getStorage } from '../../common/localStorage.js';
import { handleFile, uploadToS3 } from '../../common/picturehandle.js';

const InventoryDetail = ({ id, uid, reload, ref, setOpen, isLoading, setIsLoading, saveData, inventoryList }) => {
    let refimage = useRef();
    const { TextArea } = Input;
    const { contextHolder, error, warning } = useAlert();
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [unique, setUnique] = useState('');
    const [notes, setNotes] = useState('');
    const [instock, setInstock] = useState('1');
    const [picture, setPicture] = useState(null);
    const [status, setStatus] = useState('Active');
    const [fileToUpload, setFileToUpload] = useState(null);
    const [fileType, setFileType] = useState('');

    useEffect(() => {
        if (id === 0) {
            setName(''); setDescription(''); setUnique(''); setNotes(''); setInstock('1'); setPicture(null); setStatus('Active')
        }
        else {
            load();
        }
        
         setFileToUpload(null);setFileType('');
    }, [reload])

    const load = async () => {
        setIsLoading(true)
        const response = await FetchData({
            method: 'GET',
            endPoint: 'inventory', //
            id: id
        })
        const editList = response.data[0];
        setName(editList.name);
        setDescription(editList.description);
        setUnique(editList.unique);
        setNotes(editList.notes);
        setInstock(editList.instock);
        setStatus(editList.status);
        setPicture(editList.picture);
        setIsLoading(false)
    }
    
    const save = async () => {
        if (name !== '') {
            const isNotExist = true
            //inventoryList.filter(item => item.id !== id && item.name.toLowerCase().trim().replace(/\s+/g, '') === name.toLowerCase().trim().replace(/\s+/g, '')).length === 0;           
            if (isNotExist) {
                const Body = JSON.stringify({
                    name: name,
                    description: description,
                    unique: unique,
                    notes: notes,
                    instock: instock,
                    status: status,
                    picture: picture,
                    uid: uid
                });
                const res= await saveData({
                    label: "Inventory",
                    method: id !== 0 ? 'PUT' : 'POST',
                    endPoint: "inventory",
                    id: id !== 0 ? id : null,
                    body: Body
                });

                if (fileToUpload !== null) {
                    const Id = res.data.id;
                    const path = await uploadToS3(Id, "inventory", fileToUpload, fileType);
                    const localstoreage= await getStorage();
                    const ProfilePicBody = JSON.stringify({
                        id: Id,
                        uid:localstoreage.uid,
                        picture: path
                    });
                    await saveData({
                        label: "Inventory",
                        method: 'POST',
                        endPoint: "inventory/picture",
                        id: null,
                        body: ProfilePicBody,
                        notify: false
                    });
                }
                setOpen(false);
            }
            else
                error(`Inventory with ${name} name already Exists!`)
        }
        else {
            warning('Please, fill out the required fields !');
        }
    }
    useImperativeHandle(ref, () => {
        return {
            save,
        };
    })

    return (
        <div class='p-2'>
            <IsLoading isLoading={isLoading} rows={10} input={
                <>
                    <div class='w-full flex mb-6 items-center justify-center'>
                        <div class='flex flex-col items-center justify-center gap-2'>
                            {picture !== null ?
                                <Image width={128} height={128} src={picture} style={{ borderRadius: 10 }} /> :
                                <Avatar shape="square" size={128} style={{ backgroundColor: '#f9fafb', border: 'solid', width: 120, height: 120 }} icon={<CameraOutlined style={{ color: 'silver' }} />} />
                            }
                            <Button
                                type="primary" shape="default" icon={<CloudUploadOutlined />} size={24} style={{ width: '100px' }} onClick={() => {
                                    refimage.current.click();
                                }}>Change</Button>
                            <input type="file" ref={refimage} style={{ display: 'none' }} onChange={(event) => handleFile(event,setPicture,setFileToUpload,setFileType,error)} />
                            <p class='text-gray-400 text-xs'>Allowed *.jpeg, *.jpg, *.png</p>
                        </div>
                    </div>

                    <div class='flex flex-col font-normal gap-3 '>
                        <TextboxFlex label={'Item name'} mandatory={true} input={
                            <Input style={{ fontSize: 16 }}  placeholder="Item name" status={name === '' ? 'error' : ''} value={name} onChange={(e) => setName(e.target.value)} />
                        } />

                        <TextboxFlex label={'Description'} itemsCentre={false} input={
                            <TextArea style={{ fontSize: 16 }}  placeholder="Description" rows={4} value={description} onChange={(e) => setDescription(e.target.value)} />
                        } />

                        <TextboxFlex label={'Serial #'} input={
                            <Input style={{ fontSize: 16 }}  placeholder="Serial #" value={unique} onChange={(e) => setUnique(e.target.value)} />
                        } />
                        <TextboxFlex label={'In Stock'} input={
                            <Input style={{ fontSize: 16 }}  placeholder="In Stock" value={instock} onChange={(e) => setInstock(e.target.value)} />
                        } />
                        <TextboxFlex label={'Notes'} input={
                            <TextArea style={{ fontSize: 16 }}  placeholder="Notes" rows={4} value={notes} onChange={(e) => setNotes(e.target.value)} />
                        } />
                        <TextboxFlex label={'Status'} input={
                            <div class='flex flex-row items-center gap-2 w-full'>
                                <Button color={`${status === 'Active' ? 'cyan' : 'default'}`} variant="outlined" icon={<CheckOutlined />} onClick={() => setStatus('Active')} >Active</Button>
                                <Button color={`${status === 'Inactive' ? 'danger' : 'default'}`} variant="outlined" icon={<CloseOutlined />} onClick={() => setStatus('Inactive')} >Inactive</Button>
                            </div>
                        } />
                    </div>
                </>
            } />
            {contextHolder}
        </div>
    )
}

export default InventoryDetail